<template>
  <div>
    <nav class="navbar navbar-expand-lg">
      <router-link class="navbar-brand" to="/" style="font-size:2rem;color:#fff;">
        千農科技</router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
        style="outline: none;"
        @click="isActive = !isActive"
      >
        <span class="text-white">
          <i class="fas fa-caret-down" :class="{ 'turn':isActive}"></i></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNavDropdown">
        <ul class="navbar-nav">
          <li class="nav-item" @click="remove">
            <router-link class="nav-link after" to="/">首頁</router-link>
          </li>
          <li class="nav-item" @click="remove">
            <router-link class="nav-link after" to="/about">關於我們</router-link>
          </li>
          <li class="nav-item" @click="remove">
            <router-link class="nav-link after" to="/products">產品介紹</router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link class="nav-link after" to="/services">服務模式</router-link>
          </li> -->
          <!-- <li class="nav-item" @click="remove">
            <router-link class="nav-link after" to="/news">新聞快訊</router-link>
          </li> -->
          <li class="nav-item" @click="remove">
            <router-link class="nav-link after" to="/contactus">聯絡我們</router-link>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
import $ from 'jquery';

export default {
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    remove() {
      $('#navbarNavDropdown').removeClass('show');
      this.isActive = false;
    },
    shop() {
      // eslint-disable-next-line no-alert
      window.alert('開發中');
      this.$router.push('/');
    },
  },
};

</script>

<style lang="scss">
.turn{
  transform: rotate(180deg);
}

nav {
  z-index: 10;
  background-color: #5a4446;
  font-size: 1.2rem;
  box-shadow: 0px 1px 10px #271d1e;
  .navbar-nav {
    margin: auto;
    li {
      padding: 0 1rem;
      a{
        color: rgba(255, 255, 255, 0.664);
      }
    }
    li>.after{
      position: relative;
      transform: translateY(0px);
      transition: transform 0.3s;
    }
    li>.after:after {
      content: " ";
      position: absolute;
      left: 50%;
      right: 50%;
      bottom: 0px;
      height: 0;
      border-bottom: 1px solid #fff;
      transition: 0.3s;
    }
    li>.after:hover {
      transform: translateY(-5px);
    }
    li>.after:hover:after {
      left: 0;
      right: 0;
    }
    .activee{
      color: #fff;
    }
  }
  .dropdown-menu{
    left: 30px;
  }
}
</style>
